import { ErrorPage } from '@/components/layouts/ErrorPage';
import { getErrorStatus, getHttpStatus } from '@/services/api/errorStatus';

interface ErrorFallbackProps {
  error?: Error;
}

export function ErrorFallback({ error }: ErrorFallbackProps) {
  return (
    <ErrorPage status={getErrorStatus(error)} code={getHttpStatus(error)} detail={error?.message} />
  );
}
